export default "__VITE_ASSET__DWvhkqgq__"